<h1 ev-dialog-title>
  {{
  languageService.languageJSON.SubscriptionsDialog_Subscription }}
</h1>
<div ev-dialog-content data-testid="sub-success-container" [ngClass]="{ 'pro': type.includes('pro.'), 'proplus': type.includes('proplus.') }">
  <div class="logo">
    <img src="assets/icons/dark/logo/ev_navigation_logo.png" />
    <h2>PRO</h2>
  </div>

  @if (type.includes('proplus.')) {
  <img id="proplus-icon" src="assets/icons/default/ui/pro_logo.svg" />
  }

  <div class="content">
    <p>{{ languageService.languageJSON.SubscriptionsDialog_ThankYouForYourPurchase }}</p>
  </div>

</div>
<div ev-dialog-actions>
  <button class="ev-button primary" mat-button data-testid="sub-success-ok-btn" (click)="close()">{{
    languageService.languageJSON.Global_Ok }}</button>
</div>